import React from 'react';
import './Section6.css'

import { Link } from 'react-router-dom';

const Section6 = () => {

  return (
<section className="activities-cards section-padding">
  <div className="container">
    <div className="row">
      {/* Restaurant Card */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="card h-100 shadow-sm d-flex flex-column">
          <div className="card-img-container" style={{ height: "200px", overflow: "hidden" }}>
            <img 
              src="/sec3_restaurante.jpg" 
              className="card-img-top" 
              alt="Restaurant" 
              style={{ width: "100%", height: "200px", objectFit: "cover" }}
            />
          </div>
          <div className="card-body text-center d-flex flex-column">
            <h4 className="card-title">Restaurante</h4>
            <p className="card-text">Deleita tu paladar con el sabor de nuestra comida típica cartagenera.</p>
            <div className="mt-auto pt-3">
            <Link to="/restaurante" className="btn btn-primary">Ver Más</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Spa Card */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="card h-100 shadow-sm d-flex flex-column">
          <div className="card-img-container" style={{ height: "200px", overflow: "hidden" }}>
            <img 
              src="/spa3.jpeg" 
              className="card-img-top" 
              alt="Spa" 
              style={{ width: "100%", height: "200px", objectFit: "cover" }}
            />
          </div>
          <div className="card-body text-center d-flex flex-column">
            <h4 className="card-title">Spa</h4>
            <p className="card-text">Relaja tu cuerpo y experimenta un éxtasis sensorial en medio del bosque seco tropical.</p>
            <div className="mt-auto pt-3">
            <Link to="/spa" className="btn btn-primary">Ver Más</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Practices Card */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="card h-100 shadow-sm d-flex flex-column">
          <div className="card-img-container" style={{ height: "200px", overflow: "hidden" }}>
            <img 
              src="/practicas.JPG" 
              className="card-img-top" 
              alt="Practices" 
              style={{ width: "100%", height: "200px", objectFit: "cover" }}
            />
          </div>
          <div className="card-body text-center d-flex flex-column">
            <h4 className="card-title">Practicas</h4>
            <p className="card-text">Contamos con prácticas de Yoga y Artes marciales.</p>
            <div className="mt-auto pt-3">
              
            </div>
          </div>
        </div>
      </div>

      {/* Farm Card */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="card h-100 shadow-sm d-flex flex-column">
          <div className="card-img-container" style={{ height: "200px", overflow: "hidden" }}>
            <img 
              src="/sec3_granja.jpg" 
              className="card-img-top" 
              alt="Farm" 
              style={{ width: "100%", height: "200px", objectFit: "cover" }}
            />
          </div>
          <div className="card-body text-center d-flex flex-column">
            <h4 className="card-title">Granja</h4>
            <p className="card-text">Ven e Interactúa con nuestros animalitos de la granja y conoce más de ellos.</p>
            <div className="mt-auto pt-3">
              <Link to="/granja" className="btn btn-primary">Ver Más</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  )
}

export default Section6
